module.exports = __webpack_public_path__ + "img/renwu1.2d64a1fa.png";